import React from "react";
import { Route, Routes } from "react-router";
import ResourceNotFound from "../../Common/ResourceNotFound";
import {
  findUserOnlyOnePremission,
  findUserPremission,
} from "../Users/Roles/UserSecurityFind";
import { useUser } from "../../../Context/UserContext";
import { useClient } from "../../Context/ClientContext";
import { SettingsSections } from "../../Services/SettingService";
import { IPermissionActionType } from "../Users/Roles/UserPermissionCommonData";
import { ITypeIIsClientSpecificRoleDataType } from "../../../Context/RoleContext";
import AssetLocation from "./Location/AssetLocation";
import AssteItemsTable from "./Items/AssteItemsTable";
import AssetCategories from "./Category/AssetCategories";
import SalesInvoiceAndPurchaseBillGraph from "../SalesAndPurchase/InvoiceAndPurchaseBill/Table/SalesInvoiceAndPurchaseBillGraph";
import Depreciations from "./Depreciations/Depreciations";
import { Voucher_Type } from "../../Services/VoucherServices";

const AssetsNestedRoute: React.FC = () => {
  const { clientSpecificRole } = useUser();
  const { currentClient } = useClient();

  return (
    <div>
      <Routes>
        <Route
          path="/assetPurchase"
          element={
            findUserPremission(
              ["Voucher.Asset.11.View"],
              clientSpecificRole(),
              currentClient?.id!,
              [SettingsSections.Asset],
              {
                actionType: IPermissionActionType.View,
                dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
              }
            ) ? (
              <SalesInvoiceAndPurchaseBillGraph
                voucherType={Voucher_Type.Asset}
              />
            ) : (
              <ResourceNotFound pageHeight="100%" />
            )
          }
        />
        <Route
          path="/assetsItems"
          element={
            // findUserPremission(
            //   ["Voucher.Asset.11.View"],
            //   clientSpecificRole(),
            //   currentClient?.id!,
            //   [SettingsSections.Asset],
            //   {
            //     actionType: IPermissionActionType.View,
            //     dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
            //   }
            // ) ? (
            <AssteItemsTable />
            // ) : (
            //   <ResourceNotFound pageHeight="100%" />
            // )
          }
        />
        {/* <Route path="/addFixedAsset" element={<AssetModel />} /> */}
        <Route path="/depreciations" element={<Depreciations />} />
        <Route
          path="/disposed"
          element={
            findUserOnlyOnePremission(
              "Voucher.Asset.DisposedAsset.View",
              clientSpecificRole(),
              currentClient?.id!
            ) ? (
              // <Disposed />
              <SalesInvoiceAndPurchaseBillGraph
                voucherType={Voucher_Type.DisposedAsset}
              />
            ) : (
              <ResourceNotFound pageHeight="100%" />
            )
          }
        />
        <Route
          path="/location"
          element={
            findUserOnlyOnePremission(
              "Master.AssestsLocation.View",
              clientSpecificRole(),
              currentClient?.id!
            ) ? (
              <AssetLocation />
            ) : (
              <ResourceNotFound pageHeight="100%" />
            )
          }
        />
        <Route path="/categories" element={<AssetCategories />} />

        <Route path="*" element={<ResourceNotFound pageHeight="100%" />} />
      </Routes>
    </div>
  );
};
export default AssetsNestedRoute;
